import { render, staticRenderFns } from "./DataRow.vue?vue&type=template&id=1a185a05&scoped=true&"
import script from "./DataRow.vue?vue&type=script&lang=js&"
export * from "./DataRow.vue?vue&type=script&lang=js&"
import style0 from "./DataRow.vue?vue&type=style&index=0&id=1a185a05&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a185a05",
  null
  
)

export default component.exports